'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export default class SelectField extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    defaultValue: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    range: PropTypes.string.isRequired,
    updater: PropTypes.object.isRequired,
    error: PropTypes.string,
    model: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue,
      show: props.show,
    };
  }

  componentDidMount() {
    const ev = `${this.props.range}.show`;
    this.props.updater.addListener(ev, this.listener.bind(this));
  }

  componentWillUnmount() {
    const ev = `${this.props.range}.show`;
    this.props.updater.removeListener(ev);
  }

  listener(show) {
    if (show) {
      this.setState({show: show});
    } else {
      this.setState({show: show, value: ''});
    }
  }

  handleChange(e) {
    this.setState({value: e.target.value});
  }

  render() {
    var data = this.props.data;
    var options = [];
    var htmlFor = `${this.props.model}_${this.props.range}`;
    var id = `${this.props.model}_${this.props.range}`;
    var name = `${this.props.model}[${this.props.range}]`;
    var label = this.props.range.replace(/\b\w/g, l => l.toUpperCase());

    for (var i = 0; i < data.length; i++) {
      options.push(
        <option value={data[i].value} key={i}>{data[i].text}</option>
      );
    }

    return (
      <div className={this.state.show ? '' : 'hide'}>
        <label htmlFor={htmlFor} className="label">
          {label}
          <abbr title="required">*</abbr>
        </label>
        <select
          ref="select" id={id} name={name} value={this.state.value}
          onChange={this.handleChange.bind(this)}>
          {options}
        </select>
        {this.props.error &&
          <p ref="error" className="inline-errors">{this.props.error}</p>
        }
      </div>
    );
  }
}
